import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import useProviderPriceListItemOptionValues from '@hooks/useProviderPriceListItemOptionValues'

import type { ProviderPriceListModel } from '@models/types'

type UsePriceListDisplayModeOptions = {
  assignedServiceProductIds: number[],
  providerPriceList: ProviderPriceListModel,
}

type DefaultState = {
  selectedProductId: number | null,
}

const defaultState = {
  selectedProductId: null,
}

function usePriceListDisplayMode(options: UsePriceListDisplayModeOptions) {
  const { assignedServiceProductIds, providerPriceList } = options

  const [state, setState] = useSetState<DefaultState>(defaultState)
  const { selectedProductId } = state

  const { filteredProviderPriceListItemOptionValues } = useProviderPriceListItemOptionValues({
    filters: {
      provider_price_list_id: providerPriceList.id,
    },
    performHttpRequests: false,
    sortBy: 'none',
  })

  const shouldUseDropDown = filteredProviderPriceListItemOptionValues.length > 500

  useEffect(() => {
    if (assignedServiceProductIds.length > 0 && !selectedProductId){
      setState({ selectedProductId: assignedServiceProductIds[0] })
    }
  }, [assignedServiceProductIds.length])

  return {
    callbacks: {
      selectProductId: (id: number) => setState({ selectedProductId: id }),
    },
    selectedProductId,
    shouldUseDropDown,
  }
}

export default usePriceListDisplayMode
